// removed by extract-text-webpack-plugin
module.exports = {"left-nav":"left-nav__2__alliGM9fv"};